import widgets from '../widgets'

const {
    STATUS,
} = widgets

export default [
    STATUS({}),
]